// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__LtB3k","col":"Table_col__2Iief","fulfillmentStatus":"Table_fulfillmentStatus__1t52J","emailCol":"Table_emailCol__1Jqy9"};